import client from '../client'

export async function logout() {
  const response = await client.post<undefined>('auth-api/v1/auth/logout')

  return response.data
}
